<template>
    <div class="container feedback template-bg-gray my-position-relative">
        <md-card class="request-status loop_container bg-transparent update-request-form-common">
            <md-card-content class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main">
                <div class="card form-wrapper text-center p-20">
                    <h4 class="template-custom-title" v-if="!message.length">checking...</h4>
                    <h4 class="template-custom-title" else>{{message}}</h4>
                </div>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
import API from "../services/API";
export default {
    name: 'RequestStatus',
    props: ['ask_id', 'action', 'status', 'adminId', 'giveId'],
    data() {
        return {
            fullPage: true,
            api: new API(),
            message: ''
        }
    },
    beforeCreate() {
        if (!this.$route.query.askid || !this.$route.query.action || !this.$route.query.status || !this.$route.query.adminId || !this.$route.query.giveId) {
            this.$router.push('/');
        }
    },
    async created() {
        await this.api.get(`asks/${this.ask_id}`).then(async ask => {
            if (ask.data.status === '(8) Rejected' || ask.data.status === '(7) Closed') {
                this.message = 'Thank you';
            } else {
                let give = await ask.data.gives.filter(give => { return give._id === this.giveId; });
                if (give[0].responseState.currentState === 'In Review') {
                    await this.api.post(`asks/check-response-status`, {askId: this.ask_id, action: this.action, status: this.status, adminId: this.adminId, giveId: this.giveId}).then(response => {
                        if (this.action === 'reject') {
                            this.message = 'Thank you for your response';
                        } else if (this.action === 'approve') {
                            this.message = 'Thank you for approving the response.';
                        } else {
                            this.message = 'Thank you';
                        }
                    });
                } else {
                    this.message = 'Thank you';
                }
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ResponseStatus.vue